export default __webpack_public_path__ + "static/media/favoriteHealthgenom.3aa1b3b1.svg";